import { API_BASE_URL } from 'constants/index';
import { getAuthToken } from 'helpers/FetchHelper';
import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';

const PdfViewer = () => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const auth = getAuthToken();
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    let objectUrl: string;

    const loadPdf = async () => {
      try {
        const ids = id ? id.split(',') : [];
        const params = new URLSearchParams();
        ids.forEach((id) => params.append('ids[]', id));

        const response = await fetch(
          `${API_BASE_URL}/orders/get-pdf-order?${params.toString()}`,
          {
            method: 'GET',
            headers: {
              Accept: 'application/pdf',
              Authorization: `Bearer ${auth}`,
            },
          }
        );

        if (response.status === 200) {
          const blob = await response.blob();
          objectUrl = URL.createObjectURL(blob);
          setPdfUrl(objectUrl);
        } else {
          history.push('/');
        }
      } catch (err) {
        console.error('Failed to load PDF:', err);
        history.push('/');
      }
    };
    loadPdf();
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [auth, id, history]);

  return pdfUrl ? (
    <div style={{ height: '100vh' }}>
      <iframe
        src={pdfUrl}
        style={{ height: '100vh', width: '100%', border: 'none' }}
        title="PDF Preview"
      />
    </div>
  ) : (
    <div style={{ textAlign: 'center', paddingTop: 100 }}>
      <LoadingOutlined style={{ fontSize: 24 }} spin />
      <p style={{ marginTop: 8 }}>Loading PDF...</p>
    </div>

  );
};

export default PdfViewer;
